(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.image-block-text__button--scroll-to-section');
    if (!button) return;

    const targetClass = button.getAttribute('data-scroll-target');
    if (!targetClass) return;

    const targetElement = document.querySelector('.' + CSS.escape(targetClass));
    if (!targetElement) return;

    event.preventDefault();
    targetElement.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
})();
